import { get } from "lodash";

let lastTimeStamp = 0;
const LAST_ACTION = "LAST_ACTION";

export function timestampAction(action) {
  const stampedAction = action;

  stampedAction.$time = Date.now();

  return {
    stampedAction,
  };
}

const actionsToSync = [
  "LOGOUT",
  "LOGIN_SUCCESS",

  "CLOSE_SESSION_EXPIRE_DIALOG",
  "CLEAR_TOKEN_REFRESH_TIMEOUT",
  "TOKEN_EXPIRATION_CHECK",
  "SET_TOKEN_EXPIRATION_INTERVAL_ID",
  "SESSION_EXPIRE_DIALOG",
];

const config = {
  predicate: (actionType) => actionsToSync.includes(actionType),
};

const allowed = config.predicate;

export const actionStorageMiddleware = () => (next) => (action) => {
  if (action && !action.$time && !!allowed(action.type)) {
    try {
      const stampedAction = timestampAction(action);

      lastTimeStamp = stampedAction.$time;
      localStorage.setItem(LAST_ACTION, JSON.stringify(stampedAction));
    } catch (e) {
      // console.error('Your browser doesn\'t support localStorage');
    }
  }

  return next(action);
};

export function createStorageListener(store) {
  window.addEventListener("storage", (event) => {
    if (event.key === LAST_ACTION && event.newValue) {
      const parsedEvent = JSON.parse(event.newValue);
      const stampedAction = get(parsedEvent, "stampedAction", null);

      if (
        stampedAction &&
        stampedAction.$time !== lastTimeStamp &&
        !!allowed(stampedAction.type)
      ) {
        lastTimeStamp = stampedAction.$time;
        store.dispatch(stampedAction);
      }
    }
  });
}
